<template>
    <div class="input-wrap" :class="{error: field.validation.error, disabled: disabled}">
        <label :for="field.name">{{label}}<span v-if="field.validation.required">*</span></label>
        <select :id="field.name" :class="{changed:field.value !== field.initialValue}" :attr="selectProps"
                v-model="field.value" @change="this.change">
            <option disabled value="">Please select...</option>
            <option v-for="(option, index) in options" :value="option.value" :key="index">
                {{ option.label }}
            </option>
        </select>
        <div class="error">{{field.validation.error}}</div>
    </div>
</template>

<script>
    export default {
        name: "InputSelect",
        props: {
            field: {
                type: Object
            },
            label: {
                type: String
            },
            options: {
                type: Array,
                default: function() { return [
                    {label: 'Yes', value: 'Yes'},
                    {label: 'No', value: 'No'}
                ];}
            },
            flexibleOptions: {
                type: Boolean,
                default: false
            },
            selectProps: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        mounted: function () {
            this.checkWithinOptions();
            //Checks for default in options, and sets it if no other value is set
            if (!this.field.value){
                for (let i = 0; i < this.options.length; i++){
                    if (this.options[i].isDefault) {
                        this.field.value = this.field.initialValue = this.options[i].value;
                    }
                }
            }
        },
        methods: {
            change() {
                this.$emit('onChange', this.field);
                this.checkWithinOptions();
                this.field.validate();
            },
            checkWithinOptions(){
                let found = false;
                for (let i = 0; i < this.options.length; i++){
                    if (this.field.value === this.options[i].value){
                        found = true;
                    }
                }
                if (!found) {
                    if (this.flexibleOptions){
                        this.addValueToOptions(this.field.value);
                    } else {
                        this.field.value = '';
                    }
                }
            },
            addValueToOptions(val){
                this.options.push(
                    {
                        isDefault: false,
                        label: val,
                        value: val
                    }
                );
            }
        }
    };
</script>

<style scoped>
    
    .changed { background-color: #93c57a; }
    
</style>